import { ReactNode } from 'react';

interface SectionProps {
  /** The JSX content for the setting. */
  children: ReactNode;
}

/**
 * Represents a single trade settings item.
 */
export const Section = ({ children }: SectionProps): React.ReactElement => (
  <section className="mb-8 last:mb-0">{children}</section>
);
